@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/post-cards-4x6/the-woods-post-card-stack-content/the-woods-potency-meter/the-woods-potency-meter.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
.potency-container {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  justify-content: flex-start;
  align-items: center;
}
.potency-container .potency-label {
  font-family: "alternate-gothic-no-3-d", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.125rem;
  letter-spacing: 0.0225rem;
  text-transform: uppercase;
  line-height: 111.111%;
}
.potency-container .potency-score {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  justify-content: flex-start;
  align-items: center;
}
.potency-container .potency-score .potency-point {
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 50%;
}
/*# sourceMappingURL=the-woods-potency-meter.component.css.map */
